export interface PasswordRule {
  id: 'length' | 'upper' | 'lower' | 'digit'
  label: string
  ok: boolean
}

export const PASSWORD_MIN_LENGTH = 8

// Mirrors `password_requirements = "lower_upper_letters_digits"` and the minimum length in supabase/config.toml
export function passwordRules(password: string): PasswordRule[] {
  return [
    { id: 'length', label: `At least ${PASSWORD_MIN_LENGTH} characters`, ok: password.length >= PASSWORD_MIN_LENGTH },
    { id: 'upper', label: 'One uppercase letter (A-Z)', ok: /[A-Z]/.test(password) },
    { id: 'lower', label: 'One lowercase letter (a-z)', ok: /[a-z]/.test(password) },
    { id: 'digit', label: 'One number (0-9)', ok: /\d/.test(password) },
  ]
}

export function isStrongPassword(password: string): boolean {
  return passwordRules(password).every((r) => r.ok)
}
